export default function ({ $auth, redirect }) {
  if (!$auth.user.all_roles.some((e) => e == "SystemAdmin")) {
    return redirect("/admin");
  }
}
